import gsap from 'gsap';

import { app } from '../../utils/store';

class Team {
  constructor() {
    this.team = {
      el: document.querySelector('.s-team'),
      item: document.querySelectorAll('.team-item'),
    };

    this.y = {
      current: 0,
    };

    this.total = 0;

    this.window = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  init() {
    this.set();
    this.add();
  }

  set = () => {
    gsap.set(this.team.item, {
      opacity: 0,
      y: this.window.width * 0.25,
    });
  }

  add() {
    gsap.ticker.add(this.inview);
  }

  destroy() {
    app.scroll.resize();
    gsap.ticker.remove(this.inview);
  }

  inview = () => {
    this.y.current = Math.abs(app.scroll.data.last);

    [...this.team.item].forEach((el) => {
      const i = el;
      const b = el.getBoundingClientRect();

      if (b.top < this.window.height && el.inview === undefined) {
        this.total += 1;
        i.inview = true;

        gsap.to(i, {
          y: 0,
          opacity: 1,
          duration: 3,
          ease: 'expo.out',
          clearProps: 'all',
        });
      }
    });

    if (this.total === this.team.item.length) {
      this.destroy();
    }
  }
}

export default Team;
